import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

export async function downloadReceiptPdf(element: HTMLElement, receiptNumber: string): Promise<void> {
  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: '#ffffff',
  });

  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 10;
  const printableWidth = pageWidth - margin * 2;
  const printableHeight = pageHeight - margin * 2;
  const imageHeight = (canvas.height * printableWidth) / canvas.width;
  const imageData = canvas.toDataURL('image/png');

  let remaining = imageHeight;
  let offset = margin;

  pdf.addImage(imageData, 'PNG', margin, offset, printableWidth, imageHeight);
  remaining -= printableHeight;

  while (remaining > 0) {
    offset -= printableHeight;
    pdf.addPage();
    pdf.addImage(imageData, 'PNG', margin, offset, printableWidth, imageHeight);
    remaining -= printableHeight;
  }

  const safeName = receiptNumber.replace(/[^\w.-]+/g, '-');
  pdf.save(`Fee-Receipt-${safeName}.pdf`);
}
